<script>
  // Extensions
  import View from './View'

  // Mixins
  import LoadSections from '@/mixins/load-sections'

  export default {
    name: 'Home',

    metaInfo: { title: 'Home' },

    extends: View,

    mixins: [
      LoadSections([
        'hero',
        'time',
        'trust',
        'boxes',
        'sud',
        'smi',
      ]),
    ],
//        'other-features',
//        'reviews',


    props: {
      id: {
        type: String,
        default: 'home',
      },
    },
  }
</script>
